<template>
  <div>
    <v-list flat>
      <pc-client-side-navigation-item
        id="advisorProspectsNavigationItem"
        icon="pc-add-user"
        title="Prospects"
        :selected="activeItem == 'advisorProspects'"
        :to="'/accounts/' + $store.state.masterAccount?.id"
        :no-tooltips="sideMenuIsExpanded"
        data-id="5be64ce135441a86c2f552cee54bbdb1"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="advisorAccountHoldersNavigationItem"
        icon="pc-user-group"
        title="Account holders"
        :selected="activeItem == 'advisorAccountHolders'"
        :to="'/accounts/' + $store.state.masterAccount?.id + '/account-holders'"
        :no-tooltips="sideMenuIsExpanded"
        data-id="fd6ae2b5d3c691d26d73a0f77316aa28"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        v-if="!$store.getters.hasContextTabs"
        id="advisorReportsNavigationItem"
        icon="pc-workflow-taxes-department"
        :icon-size="13"
        title="Reports"
        :selected="activeItem == 'advisorReports'"
        :to="'/accounts/' + $store.state.masterAccount?.id + '/advisor-reports'"
        :no-tooltips="sideMenuIsExpanded"
        data-id="c325393c9b7efa0b13c19a54571eb88f"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="advisorAccountNavigationItem"
        icon="pc-settings"
        title="Account details"
        :selected="activeItem == 'advisorAccount'"
        :to="'/accounts/' + $store.state.masterAccount?.id + '/advisor-account'"
        :no-tooltips="sideMenuIsExpanded"
        data-id="c9f2f73d6b18e80077050a2bded908d4"
      ></pc-client-side-navigation-item>

      <pc-advisor-user-settings-navigation-item
        v-if="!$store.getters.hasContextTabs"
        :active-item="activeItem"
        :side-menu-is-expanded="sideMenuIsExpanded"
      ></pc-advisor-user-settings-navigation-item>
    </v-list>
  </div>
</template>

<script>
import Account from "@/shared/lib/client-sdk/models/account";
import PcClientSideNavigationItem from "@/client/components/layout/PcClientSideNavigationItem";
import PcAdvisorUserSettingsNavigationItem from "@/advisor/components/layout/PcAdvisorUserSettingsNavigationItem";

export default {
  components: {
    Account,
    PcClientSideNavigationItem,
    PcAdvisorUserSettingsNavigationItem,
  },

  props: {
    activeAccount: {
      type: Account,
      required: false,
    },
    activeItem: {
      type: String,
      required: false,
      default: "",
    },
    sideMenuIsExpanded: {
      type: Boolean,
      required: false,
      default: "",
    },
  },
};
</script>

<style lang="scss"></style>
